<template>
  <div>
    <template v-for="(item, index) in options">
      <fs-menu-divider v-if="item.divider" :key="`divider-${index}`" />
      <fs-menu-group v-else-if="item.group" :key="`group-${index}`" :title="item.group.title">
        <fs-menu-item
          v-for="(subItem, subIndex) in item.group.options"
          :key="subIndex"
          :font="font"
          :label="subItem.label"
          :icon="subItem.icon"
          :checked="isSelected(subItem)"
          @click="selectItem(subItem)"
        />
      </fs-menu-group>
      <fs-menu-item
        v-else
        :key="`item-${index}`"
        :font="font"
        :label="item.label"
        :icon="item.icon"
        :checked="isSelected(item)"
        @click="selectItem(item)"
      >
        <template #default>
          <slot name="default" :item="item"></slot>
        </template>
        <template #icon>
          <slot name="icon" :item="item"></slot>
        </template>
      </fs-menu-item>
    </template>
  </div>
</template>

<script>
import twoWayProperty from '@lib/twoWayProperty';
import lodashIsEqual from 'lodash/isEqual';
import FsMenuItem from '@components/fs-menu/fs-menu-item.vue';
import FsMenuDivider from '@components/fs-menu/fs-menu-divider.vue';
import FsMenuGroup from '@components/fs-menu/fs-menu-group.vue';

export default {
  name: 'fs-menu-select-group',

  emits: ['change', 'update:modelValue'],

  props: {
    /**
     * Contains the currently selected value.
     * @type {Object||String||null}
     */
    modelValue: {},

    options: {
      type: Array,
      default: () => [],
    },

    font: {
      type: String,
      default: 'standard',
      validate: (value) => ['standard', 'small'].includes(value),
    },
  },

  components: {
    FsMenuDivider,
    FsMenuItem,
    FsMenuGroup,
  },

  computed: {
    _localValue: twoWayProperty('modelValue'),
  },

  methods: {
    selectItem(item) {
      const newValue = this.itemAsComparableValue(item);

      // Emit the computed value, not this._localValue — the getter reads the modelValue
      // prop, which only updates on the parent's next render, so reading it back here
      // would emit the previous selection.
      this._localValue = newValue;
      this.$emit('change', newValue);
    },

    isSelected(item) {
      return lodashIsEqual(this.itemAsComparableValue(item), this._localValue);
    },

    itemAsComparableValue(item) {
      return item.hasOwnProperty('value') ? item.value : item;
    },
  },
};
</script>
